import {
  FieldItemModel
} from "./chunk-7EZQ33H5.js";
import {
  PimFieldRoute_default
} from "./chunk-7UH7HVCW.js";

// src/Pim/PimField/PimField.ts
import axios from "axios";
var AesirxPimFieldApiService = class {
  constructor() {
    this.route = null;
    this.create = async (data) => {
      try {
        const result = await this.route.create(data);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.update = async (data) => {
      try {
        const result = await this.route.update(data);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.updateStatus = async (arr, status) => {
      try {
        const listSelected = arr.map((o) => {
          return { id: o, published: status };
        });
        const result = await this.route.updateStatus(listSelected);
        if (result) {
          return result.result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getDetail = async (id = 0) => {
      try {
        const data = await this.route.getDetail(id);
        let results = null;
        if (data) {
          results = new FieldItemModel(data);
        }
        if (results) {
          results = results.toJSON();
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getList = async (filter, filterList) => {
      try {
        const data = await this.route.getList(filter, filterList);
        let listItems = null;
        let pagination = null;
        if (data?._embedded) {
          listItems = await Promise.all(
            data._embedded.item.map(async (o) => {
              return new FieldItemModel(o);
            })
          );
        }
        pagination = {
          page: data.page,
          pageLimit: data.pageLimit,
          totalPages: data.totalPages,
          totalItems: data.totalItems,
          limitStart: data.limitstart
        };
        return {
          items: listItems ?? [],
          pagination: pagination ?? {}
        };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.deleteFields = async (arr) => {
      try {
        const listSelected = await arr.map((o) => {
          return { id: o };
        });
        const result = await this.route.deleteFields(listSelected);
        if (result) {
          return result.result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.route = new PimFieldRoute_default();
  }
};

export {
  AesirxPimFieldApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
